import { AddAnother } from "./_add-another.js";
import { Autocomplete } from "./_autocomplete.js";
import { copyText } from "./_copy-button.js";
import { shadowRoot } from "./_dom-context.js";
import { initNavButton } from "./_nav-button.js";

initNavButton();

if (shadowRoot.getElementById("add-another-keyword")) {
	new AddAnother("#add-another-keyword");
}

const pauseOrRestartButton = shadowRoot.getElementById(
	"pause-or-restart-button",
);

if (pauseOrRestartButton) {
	pauseOrRestartButton.addEventListener("click", (e) => {
		const text = e.target.textContent === "Restart" ? "Pause" : "Restart";
		e.target.textContent = text;
	});
}

const autocompleteInput = shadowRoot.querySelector(
	'[data-autocomplete="true"]',
);

if (autocompleteInput) {
	// Example API mock
	const myApiFetcher = async (query) => {
		const sites = [
			{
				text: "https://www.rottentomatoes.com",
				value: "https://www.rottentomatoes.com",
			},
			{ text: "https://www.google.com", value: "https://www.google.com" },
			{ text: "https://www.youtube.com", value: "https://www.youtube.com" },
			{ text: "https://www.wikipedia.org", value: "https://www.wikipedia.org" },
			{ text: "https://www.reddit.com", value: "https://www.reddit.com" },
			{ text: "https://www.amazon.com", value: "https://www.amazon.com" },
			{ text: "https://www.github.com", value: "https://www.github.com" },
			{
				text: "https://www.stackoverflow.com",
				value: "https://www.stackoverflow.com",
			},
			{ text: "https://www.imdb.com", value: "https://www.imdb.com" },
			{ text: "https://www.netflix.com", value: "https://www.netflix.com" },
			{ text: "https://www.twitch.tv", value: "https://www.twitch.tv" },
			{ text: "https://www.facebook.com", value: "https://www.facebook.com" },
			{ text: "https://www.instagram.com", value: "https://www.instagram.com" },
			{ text: "https://www.linkedin.com", value: "https://www.linkedin.com" },
			{ text: "https://www.x.com", value: "https://www.x.com" },
			{ text: "https://www.pinterest.com", value: "https://www.pinterest.com" },
			{ text: "https://www.tiktok.com", value: "https://www.tiktok.com" },
			{ text: "https://www.apple.com", value: "https://www.apple.com" },
			{ text: "https://www.microsoft.com", value: "https://www.microsoft.com" },
			{ text: "https://www.spotify.com", value: "https://www.spotify.com" },
			{ text: "https://www.hulu.com", value: "https://www.hulu.com" },
			{
				text: "https://www.disneyplus.com",
				value: "https://www.disneyplus.com",
			},
			{ text: "https://www.yahoo.com", value: "https://www.yahoo.com" },
			{ text: "https://www.bing.com", value: "https://www.bing.com" },
			{
				text: "https://www.duckduckgo.com",
				value: "https://www.duckduckgo.com",
			},
			{ text: "https://www.cnn.com", value: "https://www.cnn.com" },
			{ text: "https://www.bbc.com", value: "https://www.bbc.com" },
			{ text: "https://www.nytimes.com", value: "https://www.nytimes.com" },
			{
				text: "https://www.theguardian.com",
				value: "https://www.theguardian.com",
			},
			{ text: "https://www.npr.org", value: "https://www.npr.org" },
			{ text: "https://www.wsj.com", value: "https://www.wsj.com" },
			{
				text: "https://www.washingtonpost.com",
				value: "https://www.washingtonpost.com",
			},
			{ text: "https://www.ebay.com", value: "https://www.ebay.com" },
			{ text: "https://www.etsy.com", value: "https://www.etsy.com" },
			{ text: "https://www.walmart.com", value: "https://www.walmart.com" },
			{ text: "https://www.target.com", value: "https://www.target.com" },
			{
				text: "https://www.craigslist.org",
				value: "https://www.craigslist.org",
			},
			{ text: "https://www.coursera.org", value: "https://www.coursera.org" },
			{
				text: "https://www.khanacademy.org",
				value: "https://www.khanacademy.org",
			},
			{ text: "https://www.edx.org", value: "https://www.edx.org" },
			{ text: "https://www.quizlet.com", value: "https://www.quizlet.com" },
			{
				text: "https://www.britannica.com",
				value: "https://www.britannica.com",
			},
			{ text: "https://www.medium.com", value: "https://www.medium.com" },
			{ text: "https://dev.to", value: "https://dev.to" },
			{ text: "https://www.codepen.io", value: "https://www.codepen.io" },
			{ text: "https://www.w3schools.com", value: "https://www.w3schools.com" },
			{
				text: "https://developer.mozilla.org",
				value: "https://developer.mozilla.org",
			},
			{
				text: "https://news.ycombinator.com",
				value: "https://news.ycombinator.com",
			},
			{ text: "https://www.yelp.com", value: "https://www.yelp.com" },
			{
				text: "https://www.tripadvisor.com",
				value: "https://www.tripadvisor.com",
			},
		];

		return sites.filter((x) => x.text.includes(query));
	};

	new Autocomplete(autocompleteInput, {
		fetchOptions: myApiFetcher,
		minLength: 2, // User must type 3 chars before fetch triggers
		debounceTime: 400, // Wait 400ms after last keystroke
		hiddenInputName: "selected_item_id", // The name attribute for form submission
	});
}

copyText(
	"#script-embed",
	"#copy-script-embed",
	"Script embed code copied",
	"Copy",
);

copyText("#view-embed", "#copy-view-embed", "View embed code copied", "Copy");

copyText(
	"#combined-embed",
	"#copy-combined-embed",
	"Combined embed code copied",
	"Copy",
);
